<template>
  <div class="container">
    <div v-if="0==CountryId1 || 130==CountryId1">
      <div class="card-header" style="text-align: center">
        <h5>
          <b>{{Message}}</b>
        </h5>
      </div>
    </div>
    <div v-else>
      <div id="printSection">
        <b-container class="bgWhite">
          <table width="100%" class="m-0">
            <tr>
              <td style="width: 100px">
                <img
                  src="../assets/media/logoKementerian.jpg"
                  border="0"
                  width="120"
                  height="100"
                  class="mr-2"
                />
              </td>
              <td style="width: 10px"></td>
              <td>
                <div>
                  <h6 class="sub-title">
                    <strong>MAJLIS AMANAH RAKYAT (MARA)</strong>
                    <br />
                    <span>Ibu Pejabat MARA,</span>
                    <br />
                    <span>21, Jalan MARA,</span>
                    <br />
                    <span>50609 KUALA LUMPUR</span>
                    <br />
                    <span>MALAYSIA</span>
                    <br />
                  </h6>
                </div>
              </td>
              <td>
                <div style="float: right; width: 250px">
                  <h6 class="sub-title">
                    <table>
                      <tr>
                        <td style="float: left; margin-top: 40px">
                          <table>
                            <tr class="right">
                              <td>Tel</td>
                              <td class="right">: 603-26132000</td>
                            </tr>
                            <tr class="right">
                              <td>Faks</td>
                              <td class="right">: 603-26913620</td>
                            </tr>
                          </table>
                        </td>
                        <td style="width: 80px; vertical-align: bottom">
                          <img
                            src="../assets/media/logoMara.png"
                            border="0"
                            width="80"
                            height="80"
                            class="mb-0"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colspan=2>
                          Laman Web : <a href="www.mara.gov.my">www.mara.gov.my</a>
                        </td>
                      </tr>
                    </table>
                  </h6>
                </div>
              </td>
            </tr>
          </table>
          <hr />
          <table width="100%">
            <tbody>
              <tr>
                <td style="width: 20px">
                </td>
                <td style="vertical-align: top;">
                  <div>
                    <table>
                      <tr class="title right">
                        <td style="width: 250px" class="sub-title">TO WHOM IT MAY CONCERN</td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td style="vertical-align: top;">
                  <div style="float: right; width: 250px">
                    <table>
                      <tr class="title">
                        <td style="width: 50px" class="sub-title">&nbsp;</td>
                        <td class="sub-title">&nbsp;</td>
                      </tr>
                      <tr class="title">
                        <td style="width: 50px" class="sub-title">&nbsp;</td>
                        <td class="sub-title">&nbsp;</td>
                      </tr>
                      <tr class="title">
                        <td style="width: 50px" class="sub-title">DATE</td>
                        <td v-if="null!=PrintDate && 0<PrintDate.length" class="sub-title">: {{PrintDate.toUpperCase()}}</td>
                        <td v-else></td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="card-body">
            <div style="margin-top: 30px" class="d-flex justify-content-center align-middle">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <strong class="sub-title">FINANCIAL AFFIDAVIT</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin-top: 30px">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <strong class="sub-title">MR / MISS</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title">:</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title">{{FirstName.toUpperCase()}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong class="sub-title">ID</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title">:</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title">{{IdentityNo}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong class="sub-title">LEVEL OF STUDY</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title">:</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title" v-if="null!=AcademicLevelNameEnglish">{{AcademicLevelNameEnglish.toUpperCase()}}</strong>
                      <strong class="sub-title" v-else>{{AcademicLevelName.toUpperCase()}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong class="sub-title">COURSE</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title">:</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong v-if="null!=Course1Name && 0<Course1Name.length" class="sub-title">{{Course1Name.toUpperCase()}}</strong>
                      <strong v-else></strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong class="sub-title">UNIVERISITY</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong class="sub-title">:</strong>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <strong v-if="null!=InstituteName && 0<InstituteName.length" class="sub-title">{{InstituteName.toUpperCase()}}</strong>
                      <strong v-else></strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin-top: 30px">
              <table>
                <tbody>
                  <tr>
                    <td align="justify">
                      <span>
                        This is to certify that the above named student will be sponsored by Majlis Amanah Rakyat (MARA).
                      </span>
                      <br />
                      <br />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td style="vertical-align: top; margin-right: 40px; padding-right: 20px;">
                      2.
                    </td>
                    <td align="justify">
                      <span>
                        Under this sponsorship MARA will be responsible for his / her financial obligations as follows :-
                      </span>
                      <br><br>
                      <div>
                        <table>
                          <tbody>
                            <tr class="row5px">
                              <td class="min">a.</td>
                              <td>&nbsp;</td>
                              <td align="justify">
                                <span>Tuition fees, examination fees and other educational fees specified.</span>
                              </td>
                            </tr>
                            <tr class="row5px">
                              <td class="min">b.</td>
                              <td>&nbsp;</td>
                              <td align="justify">
                                <span>Monthly stipend for the duration of the course to cover board and lodging.</span>
                              </td>
                            </tr>
                            <tr class="row5px">
                              <td class="min">c.</td>
                              <td>&nbsp;</td>
                              <td align="justify">
                                <span>Health insurance premium (if compulsory).</span>
                              </td>
                            </tr>
                            <tr class="row5px">
                              <td class="min">d.</td>
                              <td>&nbsp;</td>
                              <td align="justify">
                                <span>Return air passage from Kuala Lumpur to place of study.</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin-top: 30px">
              <table>
                <tbody>
                  <tr>
                    <td style="vertical-align: top; margin-right: 40px; padding-right: 20px;">
                      3.
                    </td>
                    <td align="justify">
                      <span>
                        We will undertake to pay the above expenses incurred by the student for the whole duration of his / her sponsorship subject to the student meeting the requirement.
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin-top: 30px">
              <table>
                <tbody>
                  <tr>
                    <td style="vertical-align: top; margin-right: 40px; padding-right: 20px;">
                      4.
                    </td>
                    <td align="justify">
                      <span>
                        This financial affidavit is solely for the purpose of securing university admission fo the above student.
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <div>
              <table>
                <tbody>
                  <tr>
                    <td style="vertical-align: top; margin-right: 40px; padding-right: 20px;">
                      <span>Thank you.</span>
                      <br><br>
                      <span>Yours sincerely,</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin-top: 60px">
              <table>
                <tbody>
                  <tr>
                    <td style="vertical-align: top; margin-right: 40px; padding-right: 20px;">
                      <strong>Director</strong>
                      <br />
                      <strong>Education Sponsorship Division</strong>
                      <br />
                      <strong>MARA Kuala Lumpur</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="text-align: center; margin: 0 auto">
              <table width="100%" style="text-align: center; margin-top: 375px">
                <tbody>
                  <tr>
                    <td style="text-align: center" class="subtitle">
                      <span>
                        <strong>THIS IS A COMPUTER-GENERATED DOCUMENT AND NO SIGNATURE IS REQUIRED</strong>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-container>
      </div>
      <Dialog header="Cetak Surat Tawaran" :visible.sync="displayCetak" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :containerStyle="{width: '50vw'}"
        :modal="true"
        :maximizable="true">
        <div class="p-fluid">
          <div class="field">
            Cetak Surat Tawaran
          </div>
        </div>
      </Dialog>
      <b-row>
        <b-col sm="12" class="float-right">
          <b-card>
            <b-button
              class="btn btn-lg float-right"
              type="submit"
              variant="primary"
              v-on:click="PrintSection"
            >
              <i class="fa icon-printer"></i> Cetak
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
Vue.use(PrimeVue);
Vue.use(ToastService);
import Dialog from 'primevue/dialog';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

export default {
  name: "PersonalDetails",
  components: {
    Dialog,
  },
  props: ["appId", "programId"],
  data: function () {
    return {
      AcademicLevelName: "",
      AcademicLevelNameEnglish: "",
      AppId: 0,
      appVerifyStatusId: 0,
      CountryId1: 0,
      Course1Id: 0,
      Course1Name: "",
      displayCetak: false,
      FirstName: "",
      IdentityNo: "",
      InstituteId: 0,
      InstituteName: "",
      Message: "Maklumat sedang dimuat turun",
      sCFN: 'FinancialAffidavit: ',
      timelineApplication: null,
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();
    if (isAuth) {
      await this.getPersonalDetails();
      await this.getProposedStudy();
      await this.getTimeLine();
      await this.getVerifyStatusDetails();
    }
  },
  computed: {
    PrintDate: {
      get: function () {
        return this.SuccessfulDocumentVerificationDate;
        //return this.moment().format("DD MMMM YYYY");
      },
    },
    SuccessfulDocumentVerificationDate: {
      get: function () {
        if (null != this.timelineApplication && 0 < this.timelineApplication.length) {
          let arr = _.orderBy(this.timelineApplication, ["Id"],["desc"]);
          let f = _.filter(arr, ["TypeId", 4]);
          if (0 < f.length) {
            if (6 == this.appVerifyStatusId) {
              return this.moment(f[0].CreatedDt).format("DD MMMM YYYY");
            } else {
              return '';
            }
          }
        } else {
          return '';
        }
      },
    },
  },
  methods: {
    async PrintSection() {
      //this.$htmlToPaper("printSection");
      await this.openCetak();
    },
    async openCetak() {
      //this.displayCetak = true;
      this.$htmlToPaper("printSection");
    },
    async getPersonalDetails() {
      return this.$API
        .get(this.$PersonalDetails, { withCredentials: true })
        .then((response) => {
          var info = response.data;
          if (response.status == 200 && info != null) {
            this.AppId = info.AppId;
            this.IdentityNo = info.IdentityNo;
            this.FirstName = info.FirstName;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getProposedStudy() {
      let fN = 'getProposedStudy: ';
      return this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then(async (response) => {
          var info = response.data;
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + JSON.stringify(response.data));
            this.InstituteId = info.InstituteId;
            if (0 == this.InstituteId) {
              this.InstituteName = info.InstituteNameOther;
            }
            else {
              this.InstituteName = info.InstituteName;
            }
            this.AcademicLevelName = info.AcademicLevelName;
            this.AcademicLevelNameEnglish = info.AcademicLevelNameEnglish;
            this.Course1Id = info.Course1Id;
            if (9999 == this.Course1Id) {
              this.Course1Name = info.CourseNameOther;
            }
            else {
              this.Course1Name = info.Course1Name;
            }
            this.CountryId1 = info.CountryId1;
            this.Message = 'Tidak diperlukan untuk pengajian dalam negara';
          } else {
            console.log(info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getTimeLine() {
      let fN = 'getTimeLine: ';
      return this.$API
        .get(this.$StatusHistory, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.timelineApplication = response.data;
            this.HTECHLogger(this.sCFN + fN + 'this.timelineApplication = ' + JSON.stringify(this.timelineApplication))
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getVerifyStatusDetails() {
      let fN = 'getVerifyStatusDetails: ';
      //this.HTECHLogger(this.sCFN + fN)
      this.VerifyStatus = {}; 
      return this.$API
        .get(this.$VerifyStatusDetails, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            this.appVerifyStatusId = response.data.VerifyStatusId;
          } else {
            console.log(response.data.detail);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
